import {ReactElement} from 'react';
import {Typography, TypographyProps} from '@mui/material';

interface LabelInputProps extends TypographyProps {
  align: 'center' | 'inherit' | 'justify' | 'left' | 'right';
  variant:
    | 'body1'
    | 'body2'
    | 'button'
    | 'caption'
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'inherit'
    | 'overline'
    | 'subtitle1'
    | 'subtitle2';

  label: any;
  labelColor?: string;
}

const LabelInput = (props: LabelInputProps): ReactElement => {
  const {variant, align, label, labelColor, style, ...rest} = props;

  return (
    <Typography
      {...rest}
      variant={variant}
      align={align}
      sx={style}
      color={labelColor}>
      {label}
    </Typography>
  );
};

export default LabelInput;
